import React from 'react';

import { Button } from '@/design-system/button';
import { FormModal, type FormModalTone } from '@/design-system/form-modal';

interface ConfirmActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  icon?: string;
  iconTone?: FormModalTone;
  title: string;
  description: string;
  actionLabel: string;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  icon = 'ri-alert-line',
  iconTone = 'warning',
  title,
  description,
  actionLabel,
}) => (
  <FormModal
    open={isOpen}
    onClose={onClose}
    icon={<i className={icon} />}
    iconTone={iconTone}
    title={title}
    size="sm"
    footer={
      <div className="flex items-center justify-end gap-2">
        <Button
          tone="neutral"
          style="stroke"
          size="sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Batal
        </Button>
        <Button
          size="sm"
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {isLoading ? 'Memproses…' : actionLabel}
        </Button>
      </div>
    }
  >
    <p className="text-sm text-text-sub-600 leading-relaxed">{description}</p>
  </FormModal>
);

export default ConfirmActionModal;
